<template>
  <transition-group class="progress-container" name="progress-in">
    <div class="progress-step"
    :class="{'active': index === activeConfigStep}"
    v-for="(option,index) in getConfiguration"
    :key="'step'+index"
    :style="{'--indexProgress': index}">
      <span v-if="index + 1 == configuration.length && index == activeConfigStep">Dokončení</span>
      <span v-else-if="index == activeConfigStep">{{ option.title }}</span>
      <span v-else>{{ index + 1 }}</span>
    </div>
  </transition-group>
</template>

<script>
  export default {
    props: [
      'activeConfigStep',
      'configuration'
    ],
    data: () => {
      return {
        showProgress: false
      }
    },
    computed: {
      getConfiguration() {
        return this.showProgress === true ? this.configuration : [];
      }
    },
    mounted() {
      this.showProgress = true;
    }
  }
</script>

<style lang="scss" scoped>
  .progress-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50px;
    margin-bottom: 10px;
  }

  .progress-step {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: auto;
    min-width: 30px;
    height: 30px;
    border-radius: 50%;
    margin: 0 10px;
    color: #000;
    background-color: #F5891F;
    transition: all .8s ease-in-out;

    &.active {
      background-color: #F5891F;
      border-radius: 5px;
      padding: 0px 10px;

      ~ .progress-step {
        color: #555;
        background-color: transparent;
      }

      ~ .progress-step::before {
        background-color: transparent;
      }
    }

    &:before {
      content: '';
      position: absolute;
      left: -20px;
      width: 20px;
      height: 2px;
      background-color: #F5891F;
      transition: all .4s ease-in-out;
      z-index: 10;
    }

    &:first-child::before {
      display: none;
    }
  }

  .progress-in-enter-active, .progress-in-leave-active {
    transition: opacity 1s linear;
    transition-delay: calc( .2s * var(--indexProgress));
  }

  .progress-in-enter, .progress-in-leave-to {
    opacity: 1;
  }
</style>
